// src/store/slices/rawDataSlice.js

import allProductsData  from '../../data/allProducts.json'
import fullProductsData from '../../data/moreDummies.json'
import categoriesJSON   from '../../data/categories.json'
import variantsData     from '../../data/dummyVariants.json'
import relatedItemsData from '../../data/relatedItems.json'
import accessoriesData  from '../../data/accessories.json'

export default (set, get) => ({
  allProducts: Array.isArray(allProductsData)
    ? allProductsData
    : allProductsData.products || [],

  fullProducts: Array.isArray(fullProductsData)
    ? fullProductsData
    : fullProductsData.moreDummies
      || fullProductsData.products
      || [],

  categories: Array.isArray(categoriesJSON)
    ? categoriesJSON
    : categoriesJSON.categories || [],

  variantsData,
  relatedItems: relatedItemsData,
  accessories: accessoriesData,
})